import { render } from "./OrderShipmentCard.vue?vue&type=template&id=d6c7c098"
import script from "./OrderShipmentCard.vue?vue&type=script&lang=js"
export * from "./OrderShipmentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__